"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.teamFactory = void 0;
const Factory = require("factory.ts");
const uuid_1 = require("uuid");
exports.teamFactory = Factory.Sync.makeFactory({
    is_home_team: true,
    name: 'Test Teamers',
    originator_id: Factory.each(() => uuid_1.v4()),
    originator_system: 'TeamService',
    originator_type: 'Team',
    primary_color: 'FFFFFF',
    score: '100',
});
